import script from "./Variant_SearchResults.vue?vue&type=script&setup=true&lang=js"
export * from "./Variant_SearchResults.vue?vue&type=script&setup=true&lang=js"

import "./Variant_SearchResults.vue?vue&type=style&index=0&id=85b780f0&lang=css"
import "./Variant_SearchResults.vue?vue&type=style&index=1&id=85b780f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85b780f0"]])

export default __exports__